module.exports = __webpack_public_path__ + "img/model_38_ug.e5110c92.jpg";